import styles from './industrySelector.module.css'

interface Industries {
  id: string
  name: string
}

interface IndustrySelectorProps {
  availableIndustries: Industries[]
  selectedIndustries: string[]
  maxSelections?: number
  onChange: (industries: string[]) => void
  viewMode?: boolean
  isLoading?: boolean
}

export const IndustrySelector = ({
  availableIndustries,
  selectedIndustries,
  maxSelections = 3,
  onChange,
  viewMode = false,
  isLoading = false,
}: IndustrySelectorProps) => {
  const handleIndustryChange = (industryId: string) => {
    if (viewMode) return

    const isSelected = selectedIndustries.includes(industryId)

    let newIndustries: string[]

    if (isSelected) {
      newIndustries = selectedIndustries.filter((id) => id !== industryId)
    } else if (selectedIndustries.length < maxSelections) {
      newIndustries = [...selectedIndustries, industryId]
    } else {
      return
    }

    onChange(newIndustries)
  }

  const getIndustryName = (id: string): string => {
    const industries = availableIndustries.find((ind) => ind.id === id)
    return industries ? industries.name : id
  }

  if (isLoading) {
    return <p>Loading industries...</p>
  }

  if (viewMode) {
    return (
      <div className={styles.tagsList}>
        {selectedIndustries.map((industryId) => (
          <span key={industryId} className={styles.tag}>
            {getIndustryName(industryId)}
          </span>
        ))}
        {selectedIndustries.length === 0 && <span className={styles.noIndustries}>No industries selected</span>}
      </div>
    )
  }

  return (
    <div className={styles.industriesSelector}>
      <div className={styles.industriesList}>
        {availableIndustries.map((industry) => {
          const isSelected = selectedIndustries.includes(industry.id)
          const isDisabled = selectedIndustries.length >= maxSelections && !isSelected

          return (
            <button
              type="button"
              key={industry.id}
              className={`${styles.industryItem} ${
                isSelected ? styles.industryItemSelected : ''
              } ${isDisabled ? styles.industryItemDisabled : ''}`}
              onClick={() => handleIndustryChange(industry.id)}
              disabled={isDisabled}
            >
              {industry.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default IndustrySelector
